import React from "react";
import { AppContext } from "../../HomePage";
import { GROUPS, SECTIONS, visibleSectionKeys } from "./AccountSections";

const AccountNav = ({ activeKey, onSelect }) => {
    const { t } = React.useContext(AppContext);
    const visible = visibleSectionKeys();
    const items = SECTIONS.filter(s => visible.includes(s.key));

    return (
        <nav className="acc-rail" aria-label={t('account.nav.aria', 'Account settings')}>
            {GROUPS.map(group => {
                const groupItems = items.filter(s => s.group === group.key);
                if (groupItems.length === 0) return null;
                return (
                    <React.Fragment key={group.key}>
                        <div className="acc-grp">{t(group.labelKey, group.defaultLabel)}</div>
                        {groupItems.map(s => (
                            <button key={s.key} type="button"
                                    className={"acc-nav" + (s.key === activeKey ? " is-active" : "")}
                                    aria-current={s.key === activeKey ? "page" : undefined}
                                    onClick={() => onSelect(s.key)}>
                                <i className={"pi " + s.icon} />{t(s.labelKey, s.defaultLabel)}
                            </button>
                        ))}
                    </React.Fragment>
                );
            })}
        </nav>
    );
};
export default AccountNav;
